module.exports = __webpack_public_path__ + "img/packshot.691c1962.png";